module.exports = __webpack_public_path__ + "img/Logo1.db706797.png";